import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';

class MachineHideSelector extends Component {

    static propTypes = {
        translate: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    static defaultProps = {
        activeView: 'smallView',
        options: [],
        selected: 0,
    };

    constructor(props) {

        super(props);

        this.state = {
            selected: props.selected
        };

        this.translate = this.props.translate;

        this.onClickHandle = this.onClickHandle.bind(this);

    }

    onClickHandle(option) {

        if (option) {
            const pastTime = option.value;

            if (this.props.onClick) this.props.onClick(pastTime);

            this.setState({
                selected: pastTime
            });
        }

    }

    getSortOptions() {

        //const labelOfMonth = this.translate('afterOneMonth');
        const labelOfMonths = this.translate('afterXMonths');
        const millisecondsOfOneDay = 60 * 60 * 24 * 1000;

        return [
            {
                value: 0,
                label: this.translate('neverHide'),
            },
            {
                value: millisecondsOfOneDay * 30 * 3,
                label: labelOfMonths.replace('__COUNTER__', 3),
            },
            {
                value: millisecondsOfOneDay * 33 * 6,
                label: labelOfMonths.replace('__COUNTER__', 6),
            },
            {
                value: millisecondsOfOneDay * 365,
                label: labelOfMonths.replace('__COUNTER__', 12),
            }
        ];

    }

    render() {

        if (this.props.activeView === 'tableView') return null;

        const sortedOptions = this.getSortOptions();

        return (
            <span className="machineHideSelector">
                <Select
                    name="form-sort-selector"
                    className="chosen-container chosen-container-single"
                    style={{width: '200px'}}
                    options={sortedOptions}
                    onChange={this.onClickHandle}
                    value={this.state.selected}
                    placeholder={this.translate('sorting')}
                    clearable={false}
                    noResultsText={this.translate('noResultsFound')}
                />
            </span>
        );

    }

}

export default MachineHideSelector;